import { Link } from 'react-router-dom';
import './BlindsCategory.css';


// Updated array (removed 5th & 6th items, renamed images)
const blinds = [
  { title: 'Skylight Blinds', desc: 'Enjoy Privacy and An Open View At The Same Time', img: '/Assets/CategoryImages/Skylight.webp', link: '/products/skylight-blinds' },
  { title: 'Grayson Blinds', desc: 'Give You Privacy while Offering A View to the Outside', img: '/Assets/CategoryImages/Grayson.webp', link: '/products/grayson-blinds' },
  { title: 'Luzon Blinds', desc: 'Innovative Window Furnishing', img: '/Assets/CategoryImages/Luzon.webp', link: '/products/luzon-blinds' },
  { title: 'Sierra Blinds', desc: 'Decorating Your Home that Combines the Practical Qualities', img: '/Assets/CategoryImages/Sierra.webp', link: '/products/sierra-blinds' },

  { title: 'Colby Blinds', desc: 'Most Energy Efficient Blinds', img: '/Assets/CategoryImages/Colby.webp', link: '/products/colby-blinds' },
  { title: 'Printed Blinds', desc: 'Personalize Your Blinds with Your Favourite Designs', img: '/Assets/CategoryImages/Printed.webp', link: '/printed-blinds' },
  // Removed Colby and Printed blinds (indexes 4 and 5)
  { title: 'Wooden Blinds', desc: 'Add a Timeless Style to your Windows', img: '/Assets/CategoryImages/Wooden.webp', link: '/products/wooden-venetian-blinds' },
  { title: "Roman Blinds", desc: 'Convert Sheer Fabrics into Translucent & Blackout and Translucent to Blackout', img: '/Assets/CategoryImages/Roman.webp', link: '/products/roman-blinds' },
  { title: "Arcline Blinds", desc: 'Elevate Your Space with Stylish Arcline Blinds', img: '/Assets/CategoryImages/Arcline.webp', link: '/products/arcline-blinds' },
  { title: 'Automation', desc: 'Control Your Blinds with Your Smartphone', img: '/Assets/CategoryImages/c8.webp', link: '/automation' },
  { title: 'Curtain', desc: 'Blackout & Sheer', img: '/Assets/CategoryImages/3Curtain.webp', link: '/products/roller-blinds' },
  { title: 'Curtain Tracks', desc: 'Marvel Curtain Tracks for Smooth Operation', img: '/Assets/CategoryImages/Tracks.webp', link: '/automation' },

  // NEW ROW — placeholder images used temporarily, replace img/title/desc/link later
  { title: 'Blinds with Curtains', desc: 'Hotel Project', img: '/Assets/CategoryImages/FullSizeRender4.webp', link: 'https://marvelcallistus.com' },
  { title: 'Roller Blinds', desc: 'Square Fascia', img: '/Assets/CategoryImages/10_Curtain_with_Blinds.webp', link: '/products' },
];


const BlindsCategory = () => {
  const paired = [];
  for (let i = 0; i < blinds.length; i += 2) {
    paired.push(blinds.slice(i, i + 2));
  }

  return (
    <section className="CategorySection">
      <div className="blinds-section">
        <h2 className="blinds-title">Customized Window Blinds</h2>
        <p className="blinds-subtitle">
          Explore how Marvel Blinds window treatments transform the light into your home or offices,
          elevating everyday living and add beauty to the mood of your unique space.
        </p>

        <div className="blinds-wrapper">
          {paired.map((pair, index) => {
            const rowClass =
              index === paired.length - 1 ? 'row-3' : `row-${(index % 5) + 1}`;
            return (
              <div className={`blinds-row ${rowClass}`} key={index}>
                {pair.map((item, subIndex) => {
                  const isExternal = item.link.startsWith('http');
                  const CardTag = isExternal ? 'a' : Link;
                  const cardProps = isExternal
                    ? { href: item.link, target: '_blank', rel: 'noopener noreferrer' }
                    : { to: item.link };

                  return (
                    <CardTag
                      className={`blinds-card card-${subIndex + 1}`}
                      key={subIndex}
                      {...cardProps}
                    >
                      <div className="blinds-image-wrapper">
                        <img src={item.img} alt={item.title} className="blinds-image" />
                      </div>
                      <div className="blinds-text">
                        <div className="blinds-label">{item.title}</div>
                        <div className="blinds-subtext">{item.desc}</div>
                      </div>
                    </CardTag>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ marginTop: "10px" }} className="footer-column">
        <button className='seeProdBtn' onClick={() => (window.location.href = "/products")}>
          See All Products
        </button>
      </div>


    </section>
  );
};

export default BlindsCategory;